import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import debounce from 'debounce-promise';
import { useFormikContext } from 'formik';
import React, { useEffect, useMemo, useRef, useState } from 'react';

dayjs.extend(localizedFormat);

interface AutoSaveProps {
  debounceMs: number;
  showLastSaveMessage?: boolean;
}

const AutoSave = ({ debounceMs, showLastSaveMessage = false }: AutoSaveProps) => {
  const didMount = useRef(false);
  const formik = useFormikContext();
  const [lastSaved, setLastSaved] = useState<string>('');
  const debouncedSubmit = useMemo(
    () =>
      debounce(
        () => formik.submitForm().then(() => setLastSaved(dayjs().format('lll'))),
        debounceMs
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debounceMs, formik.submitForm]
  );

  useEffect(() => {
    // to prevent from saving on load, check that page has been loaded
    if (didMount.current) {
      debouncedSubmit();
    } else {
      didMount.current = true;
    }
  }, [debouncedSubmit, formik.values]);

  const lastSavedMessage = lastSaved !== null ? `Last saved: ${lastSaved}` : null;
  const savingMessage = formik.isSubmitting ? 'Saving…' : lastSavedMessage;

  return <>{!showLastSaveMessage ? null : savingMessage}</>;
};

export default AutoSave;
